
//const API_URl ='http://localhost:8080/api';


const API_URl ='https://api.ngady.com/api';


export default API_URl;